export default __webpack_public_path__ + "static/media/Drive-main.a492e21d.svg";